interface Log {
  fn: string;
  argTypes: string[];
  argValues: any[];
  result: any;
}

export default {
  namespaced: true,
  state: {
    code: '',
    logs: []
  },
  getters: {
    isLogsReturned(state) {
      return state.logs.length > 1;
    }
  },
  mutations: {
    setCode(state, code) {
      state.code = code;
    },
    addLog(state, log: Log) {
      state.logs.push(log);
    },
    resetLogs(state) {
      state.logs = [];
    }
  }
};
